import { IControl } from "../icontrol";
import { ControlType } from "../../controltype";

/**
 * 数字区间控件
 */
export class NumberRangeControl implements IControl{

    /**
     * 获取控件类型
     */
    getControlType(): ControlType {
        return ControlType.NumberRange;
    }

    /**
     * 长度
     */
    length:number;

    /**
     * 精度
     */
    precision:number;
    /**
     * 默认显示
     */
    placeholder:string;
    beginPlaceHolder:string;
    endPlaceHolder:string;
    /**
     * 是否是展示在扩展区域内的
     */
    isExtend:boolean;

    /**是否显示label */
    showLabel:boolean;

    /**是否必填 */
    required:boolean;
    /**是否是大数 */
    bigNumber:boolean;
}